import React from 'react'
import { BtnCreate, BtnDelete, H1, H2, H3, Section, P, InfoBox, Grid12, BadgeOpenQuestion } from '../components/StyledComponents'

const StyledComponentsShowcase = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <H1>Styled Components Showcase</H1>
      <P>This page demonstrates all available styled components in our design system.</P>

      <Section>
        <H2>Typography Components</H2>
        
        <div style={{ marginBottom: '2rem' }}>
          <H3>H1 - Main Heading</H3>
          <H1>This is an H1 heading example</H1>
        </div>

        <div style={{ marginBottom: '2rem' }}>
          <H3>H2 - Secondary Heading</H3>
          <H2>This is an H2 heading example</H2>
        </div>

        <div style={{ marginBottom: '2rem' }}>
          <H3>H3 - Tertiary Heading</H3>
          <H3>This is an H3 heading example</H3>
        </div>

        <div style={{ marginBottom: '2rem' }}>
          <H3>P - Paragraph</H3>
          <P>This is a paragraph component. It can contain longer text content and maintains consistent styling throughout the application. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</P>
        </div>
      </Section>

      <Section>
        <H2>Button Components</H2>
        
        <div style={{ marginBottom: '1rem' }}>
          <H3>Create Button</H3>
          <BtnCreate onClick={() => alert('Create button clicked!')}>
            Create New Item
          </BtnCreate>
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <H3>Delete Button</H3>
          <BtnDelete onClick={() => alert('Delete button clicked!')}>
            Delete Item
          </BtnDelete>
        </div>
      </Section>

      <Section>
        <H2>Layout Components</H2>
        
        <div style={{ marginBottom: '2rem' }}>
          <H3>Section</H3>
          <P>The Section component you see here wraps content sections with consistent spacing and styling.</P>
        </div>

        <div style={{ marginBottom: '2rem' }}>
          <H3>Grid12 - 12 Column Grid</H3>
          <Grid12>
            <div style={{ background: '#f0f0f0', padding: '1rem', margin: '0.5rem', borderRadius: '4px' }}>
              Grid Item 1
            </div>
            <div style={{ background: '#f0f0f0', padding: '1rem', margin: '0.5rem', borderRadius: '4px' }}>
              Grid Item 2
            </div>
            <div style={{ background: '#f0f0f0', padding: '1rem', margin: '0.5rem', borderRadius: '4px' }}>
              Grid Item 3
            </div>
            <div style={{ background: '#f0f0f0', padding: '1rem', margin: '0.5rem', borderRadius: '4px' }}>
              Grid Item 4
            </div>
          </Grid12>
        </div>
      </Section>

      <Section>
        <H2>Information Components</H2>
        
        <div style={{ marginBottom: '2rem' }}>
          <H3>InfoBox</H3>
          <InfoBox>
            <P>This is an InfoBox component. It's used to display important information, tips, or notifications to users. The styling helps draw attention to key content.</P>
          </InfoBox>
        </div>

        <div style={{ marginBottom: '2rem' }}>
          <H3>BadgeOpenQuestion</H3>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <P>Question status:</P>
            <BadgeOpenQuestion>Open Question</BadgeOpenQuestion>
          </div>
        </div>
      </Section>

      <Section>
        <H2>Interactive Examples</H2>
        <P>Here are some interactive examples showing how these components work together:</P>
        
        <InfoBox>
          <H3>Component Combination Example</H3>
          <P>This InfoBox contains multiple components working together.</P>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
            <BtnCreate onClick={() => alert('Combined create action!')}>
              Add New
            </BtnCreate>
            <BtnDelete onClick={() => alert('Combined delete action!')}>
              Remove
            </BtnDelete>
          </div>
        </InfoBox>

        <Grid12 style={{ marginTop: '2rem' }}>
          <InfoBox className='col-span-6'>
            <H3>Grid + InfoBox</H3>
            <P>Components can be nested within the grid system.</P>
            <BadgeOpenQuestion>Status: Active</BadgeOpenQuestion>
          </InfoBox>
          <InfoBox className='col-span-6'>
            <H3>Another Grid Item</H3>
            <P>Each grid item can contain different content and components.</P>
            <div style={{ marginTop: '1rem' }}>
              <BtnCreate onClick={() => alert('Grid item action!')}>
                Grid Action
              </BtnCreate>
            </div>
          </InfoBox>
        </Grid12>
      </Section>
    </div>
  )
}

export default StyledComponentsShowcase